import { motion } from "framer-motion";
import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { IMAGES } from "../lib/constants";

const RESULTS = [
  { value: "₹168 Cr", label: "Annual revenue opportunity unlocked from neglected brands" },
  { value: "40–50%", label: "OPEX reduction via variable, performance-based model" },
  { value: "1–2 Yrs", label: "Breakeven vs 3–4 years with traditional high fixed costs" },
  { value: "2×", label: "Field force productivity vs comparable traditional setups" },
];

export default function Impact() {
  return (
    <section id="impact" className="py-20 md:py-32 bg-slate-50 border-y border-slate-200" data-testid="impact-section">
      <div className="max-w-7xl mx-auto px-6 md:px-10 grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <div className="lg:col-span-5 order-2 lg:order-1">
          <div className="text-xs font-bold uppercase tracking-[0.2em] text-teal-700 mb-3">
            Real Impact, Real Results
          </div>
          <h2 className="font-display text-4xl md:text-5xl lg:text-[56px] font-extrabold leading-[1.04] text-slate-900 mb-6">
            Revitalizing a <br />
            <span className="font-editorial italic font-medium text-slate-700">stagnant portfolio.</span>
          </h2>
          <p className="text-slate-600 text-base md:text-lg leading-relaxed mb-8">
            For a Top-10 Indian pharma division — 70% mature & tail-end portfolio receiving inadequate attention —
            Medstry implemented the 3D Delta Field Force Model. Within 18 months, neglected brands
            became the division's growth story.
          </p>

          <div className="flex flex-wrap items-center gap-3">
            <a
              href="/#contact"
              data-testid="impact-cta"
              className="inline-flex items-center gap-2 btn-primary px-6 py-3.5 text-sm font-semibold"
            >
              Request Your Case Brief
            </a>
            <Link
              to="/impact"
              data-testid="impact-read-full"
              className="inline-flex items-center gap-1.5 text-sm font-semibold text-slate-900 border-b border-slate-900 pb-1 hover:text-teal-700 hover:border-teal-700 transition-colors"
            >
              Read full case <ArrowRight className="h-4 w-4" />
            </Link>
          </div>
        </div>

        <div className="lg:col-span-7 order-1 lg:order-2">
          <div className="relative">
            <img
              src={IMAGES.facility}
              alt="Modern pharmaceutical facility"
              className="w-full aspect-[5/4] object-cover bg-slate-200"
            />
            <div className="absolute -bottom-6 -left-6 right-6 md:right-auto md:w-2/3 bg-[#0B0F19] text-white p-6 md:p-8">
              <div className="text-[11px] font-bold uppercase tracking-[0.18em] text-teal-300 mb-3">
                Outcomes
              </div>
              <div className="grid grid-cols-2 gap-x-6 gap-y-5">
                {RESULTS.map((r, i) => (
                  <motion.div
                    key={r.label}
                    initial={{ opacity: 0, y: 10 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ delay: i * 0.08 }}
                    data-testid={`impact-stat-${i}`}
                  >
                    <div className="font-display text-2xl md:text-3xl font-extrabold tnum">{r.value}</div>
                    <div className="text-xs text-slate-400 mt-1.5 leading-snug">{r.label}</div>
                  </motion.div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
